var _path, _path2, _path3, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBuilderTemplateJournalA4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3780,
    height: 2646,
    fill: "none",
    viewBox: "0 0 3780 2646",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    stroke: "red",
    strokeWidth: 1,
    d: "M112.15 117.87h1582.92V2528.2H112.15zm1972.54.19h1583.06V2528.2H2084.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    stroke: "#0080FF",
    strokeWidth: 1,
    d: "M76.99 82.96h3625.48v2479.47H76.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    stroke: "#0080FF",
    strokeDasharray: "6 6",
    strokeWidth: 1,
    d: "M2049.25 83v2479.48M1954.79 83v2479.48M1824.73 83v2479.48M1730.64 83v2479.48"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 180,
    className: "red"
  }, "Safe Area")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 2760,
    y: 180,
    className: "red"
  }, "Safe Area")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 736,
    y: 1358,
    className: "large"
  }, "Back")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 2700,
    y: 1358,
    className: "large"
  }, "Front")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 850,
    y: 2620
  }, "Bleed")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 2805,
    y: 2620
  }, "Bleed")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1780,
    y: 1225,
    className: "vertical"
  }, "Hinge")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1900,
    y: 1225,
    className: "vertical"
  }, "Spine")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 2005,
    y: 1225,
    className: "vertical"
  }, "Hinge")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    text {\r\n      font-family:sans-serif;\r\n      fill: black;\r\n      font-size: 50px;\r\n      paint-order: stroke;\r\n      stroke: #fff;\r\n      stroke-width: 20px;\r\n      stroke-linecap: butt;\r\n      stroke-linejoin: round;\r\n      opacity: .66;\r\n    }\r\n    .large {\r\n      font-size: 150px;\r\n      stroke-width: 40px;\r\n    }\r\n    .red {\r\n      fill: red;\r\n    }\r\n    .vertical {\r\n      writing-mode: vertical-lr;\r\n    }\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBuilderTemplateJournalA4);
export default __webpack_public_path__ + "static/media/product-builder-template_journal-A4.b31f54b78b7aacec675ff9c9f5dee38c.svg";
export { ForwardRef as ReactComponent };